import { QueryParams, QueryParamsActions, QueryParamsScheme, User } from '../types';
import { getQueryParam } from './queryParamsService';
import { PlansIds } from '../constants/config';
import { openChangePlanChat, typeTextIntoSupportChat } from './SupportChatService';

export class SubscriptionService {

  private static instance: SubscriptionService = null;

  private constructor(private readonly user: User) {
    SubscriptionService.instance = this;

    const action = getQueryParam(QueryParams.ACTION) as QueryParamsScheme[QueryParams.ACTION];

    if (action === QueryParamsActions.CANCEL_SUBSCRIPTION) {
      this.cancelSubscription();
    }
  }

  private static GetInstance(): SubscriptionService {
    if (SubscriptionService.instance) {
      return SubscriptionService.instance;
    }

    throw new Error('SubscriptionService is not init. Use SubscriptionService.SetUser() first');
  }

  static SetUser(user: User) {
    new SubscriptionService(user);
  }

  private cancelSubscription(): void {
    openChangePlanChat(this.getCancelMessage());
  }

  private getCancelMessage(): string {
    switch (this.user.subscription?.plan) {
      case PlansIds.STANDARD_PLUS:
        return 'PlansIds.STANDARD_PLUS';
      case PlansIds.PRO:
        return 'PlansIds.PRO';
      case PlansIds.STARTER:
        return 'PlansIds.STARTER';
      case PlansIds.GROWTH:
        return 'PlansIds.GROWTH';
    }
  }
}